<template>
  <div class="chart" ref="lineChart"></div>
</template>

<script>
import echarts from 'echarts';
import ChartStyleHelper from '@/helpers/chartStyleHelper';
import ChartFunctionHelper from '@/helpers/chartFunctionHelper';
import FuncHelper from '@/helpers/funcHelper';

export default {
  name: 'lineChart',
  props: {
    data: {
      type: Object,
      required: true
    },
    showSlider: {
      type: Boolean,
      default: true
    },
    color: {
      type: String
    },
    color1: {
      type: String
    }
  },
  data() {
    return {
      chart: null
    };
  },
  methods: {
    chartOption() {
      const grid = Object.assign({}, ChartStyleHelper.grid, {
        top: 10,
        left: -45,
        bottom: -20,
        right: -6
      });
      const xAxisConfig = {
        type: 'category',
        data: this.data.fields.map(v => {
          return {
            value: v,
            textStyle: {
              fontSize: 12
            }
          };
        }),
        axisPointer: {
          type: 'line'
        },
        axisLine: {
          lineStyle: {
            color: '#37353b60'
          }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          showMinLabel: false,
          showMaxLabel: false
        }
      };
      const yAxisConfig = {
        type: 'value',
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: ['transparent'],
            type: 'solid'
          }
        }
      };
      const option = {
        grid,
        xAxis: [xAxisConfig],
        yAxis: [yAxisConfig],
        series: this.data.series.map(v => { 
          return {
            name: v.name,
            type: 'line',
            data: this.data.fields.map(field => v[field]),
            symbol: 'image://data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTNweCIgaGVpZ2h0PSIxM3B4IiB2aWV3Qm94PSIwIDAgMTMgMTMiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzLjIgKDcyNjQzKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5PdmFsPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9InBhZ2UiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSIzdGFn6K+m5oOFIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTE4OC4wMDAwMDAsIC0zNTIuMDAwMDAwKSIgZmlsbD0iIzNFM0M0MiIgZmlsbC1ydWxlPSJub256ZXJvIiBzdHJva2U9IiNGQjRCNTYiIHN0cm9rZS13aWR0aD0iNCI+CiAgICAgICAgICAgIDxnIGlkPSJQYXRoLTE0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5NTIuMDAwMDAwLCAyNjIuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBjeD0iMjQyLjUiIGN5PSI5Ni41IiByPSI0LjUiPjwvY2lyY2xlPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=',
            symbolSize: 6,
            showSymbol: false,
            smooth: true,
            borderColor: 'white',
            areaStyle: {},
            lineStyle: {
              color: 'transparent'
            },
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              areaStyle: {},
              colorStops: [{
                offset: 0, color: this.color // 0% 处的颜色
              }, {
                offset: 1, color: this.color1 // 100% 处的颜色
              }],
              global: false // 缺省为 false
            },
            borderWidth: 2,
            emphasis: {
              itemStyle: {
                borderColor: 'white'
              }
            }
          };
        })
      };
      return option;
    },
    generateChart() {
      const lineChart = echarts.init(this.$refs.lineChart);
      const option = this.chartOption();
      lineChart.setOption(option);
      lineChart.on('finished', () => {
        const imgUrl = lineChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: '#fff'
        });
        this.$emit('done', imgUrl);
      });
      ChartFunctionHelper.preventLastSeriesUnseleted(lineChart);
      return lineChart;
    },
    resize() {
      if (this.chart) {
        FuncHelper.debounce(this.chart.resize, 300)();
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.resize);
    this.chart = this.generateChart();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
    if (this.chart) {
      this.chart.dispose();
    }

    if (this.chart) {
      this.chart.off('finished');
    }
  }
};
</script>

<style lang="scss" scoped>
.chart{
  width:100%;
  height: 100%;
}
</style>
